export default {
	workspace_drop_zone_hide: 'Hide dropzone',
	workspace_drop_zone_new_mail: 'New email',
	workspace_drop_zone_save_to_document_postbox: 'Save to document storage:',
	workspace_drop_zone_send_via_mail: 'Send via mail',
	workspace_drop_zone_send_via_mail_limit_message: 'One file at a time via drag & drop',
	workspace_drop_zone_upload_failed_prefix: 'Upload failed: ',
};
